import SimplifiedEditor from 'Components/RichEditor/SimplifiedEditor';

const ViewActivity = ({ resource }) => (
  <div className='activity-view'>
    <SimplifiedEditor content={resource} editable={false} />
  </div>
);

export default ViewActivity;
